import { render, staticRenderFns } from "./PlanetFarms.vue?vue&type=template&id=04348636&"
import script from "./PlanetFarms.vue?vue&type=script&lang=ts&"
export * from "./PlanetFarms.vue?vue&type=script&lang=ts&"
import style0 from "./PlanetFarms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports